import styled from "styled-components";

export const TooltipStyle = styled.div`
    display: inline-block;
    position: relative;
    padding-bottom: 4px;
`;

export const QuestionStyle = styled.div`
    width: 16px;
    height: 16px;
    padding: 4px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-origin: content-box;
`;

export const QuestionContent = styled.div`
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 1000;
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    color: #333;
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    white-space: normal;
    text-align: left;
    transform: translateY(100%);
    &:before{
        content: "";
        position: absolute;
        left: 50%;
        top: 0;
        transform: translate(-50%, -100%);
        border-bottom: 5px solid #fff;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
    }
`;
